export const PROFILE_EMPLOYMENT_ERROR = 'PROFILE_EMPLOYMENT_ERROR';
export const PROFILE_EMPLOYMENT_LOADING = 'PROFILE_EMPLOYMENT_LOADING';
export const PROFILE_EMPLOYMENT_SUCCESS = 'PROFILE_EMPLOYMENT_SUCCESS';